"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var slideout_1 = __importDefault(require("../helpers/slideout"));
var slider_1 = __importDefault(require("../helpers/slider"));
var Menu = /** @class */ (function () {
    function Menu() {
        this.config = {
            slideout: null,
            slider: null,
            htmlElements: {
                slider: null
            },
            nodeLists: {
                main: null,
                open: null,
                close: null,
                submenusOpen: null,
                submenus: null,
                submenusBack: null
            },
            selectors: {
                main: '[data-menu]',
                open: '[data-menu-open]',
                close: '[data-menu-close]',
                slider: '[data-menu-slider]',
                submenuOpen: '[data-submenu-open]',
                submenu: '[data-submenu]',
                submenuBack: '[data-submenu-back]'
            }
        };
    }
    Menu.prototype.init = function () {
        this.load();
        this.addEventListeners();
    };
    Menu.prototype.reinit = function () {
        this.init();
    };
    Menu.prototype.addEventListeners = function () {
        var _this = this;
        this.config.nodeLists.open.forEach(function (htmlElement) { return htmlElement.addEventListener('click', _this.open.bind(_this)); });
        this.config.nodeLists.close.forEach(function (htmlElement) { return htmlElement.addEventListener('click', _this.close.bind(_this)); });
        this.config.nodeLists.submenusOpen.forEach(function (htmlElement) { return htmlElement.addEventListener('click', _this.openSubmenu.bind(_this)); });
        this.config.nodeLists.submenusBack.forEach(function (htmlElement) { return htmlElement.addEventListener('click', _this.backSubmenu.bind(_this)); });
        this.config.slider.events.on('transitionEnd', this.resetSubmenus.bind(this));
    };
    Menu.prototype.load = function () {
        this.config.nodeLists.main = document.querySelectorAll(this.config.selectors.main);
        this.config.nodeLists.open = document.querySelectorAll(this.config.selectors.open);
        this.config.nodeLists.close = document.querySelectorAll(this.config.selectors.close);
        this.config.htmlElements.slider = document.querySelector(this.config.selectors.slider);
        this.config.nodeLists.submenus = document.querySelectorAll(this.config.selectors.submenu);
        this.config.nodeLists.submenusOpen = document.querySelectorAll(this.config.selectors.submenuOpen);
        this.config.nodeLists.submenusBack = document.querySelectorAll(this.config.selectors.submenuBack);
        this.config.slider = this.slider();
        this.update();
    };
    Menu.prototype.update = function () {
        var _this = this;
        this.config.nodeLists.main.forEach(function (htmlElement) { return _this.config.slideout = _this.slideout(htmlElement); });
    };
    Menu.prototype.slider = function () {
        return slider_1.default.init(this.config.htmlElements.slider, { items: 1, gutter: 0, loop: false, touch: false });
    };
    Menu.prototype.slideout = function (htmlElement) {
        return slideout_1.default.init(htmlElement, {
            side: 'right'
        });
    };
    Menu.prototype.openSubmenu = function (event) {
        var target = event.target;
        var submenuName = target.dataset.submenuOpen;
        var submenu = null;
        if (submenuName)
            submenu = this.getSubmenu(submenuName);
        if (submenu)
            submenu.classList.remove('hide'), this.config.slider.goTo(2);
    };
    Menu.prototype.backSubmenu = function (event) {
        this.config.slider.goTo('first');
    };
    Menu.prototype.resetSubmenus = function () {
        var sliderInfo = this.config.slider.getInfo();
        if (sliderInfo.index === 0)
            this.config.nodeLists.submenus.forEach(function (htmlElement) { return htmlElement.classList.add('hide'); });
    };
    Menu.prototype.getSubmenu = function (submenuName) {
        return Array.from(this.config.nodeLists.submenus).find(function (htmlElement) { return htmlElement.dataset.submenu === submenuName; });
    };
    Menu.prototype.open = function () {
        this.config.slideout.open();
    };
    Menu.prototype.close = function () {
        this.config.slideout.close();
    };
    return Menu;
}());
exports.default = new Menu();
